import { usePricing } from "../../context/PricingContext";
import { useI18n } from "../../i18n";

/**
 * RC-WEB-2 §16-B/C — tarjeta comercial de auth alimentada SIEMPRE por el plan
 * publicado desde el master admin (nunca por precios ni duraciones hardcodeadas).
 * Reacciona al país seleccionado en el formulario de registro.
 */
export const AuthPlanCard = ({ months, testId }) => {
  const { planByMonths, defaultPlan, planPriceLabel, planChargeLabel, pricingLoading, approxHint, noEstimateNote } = usePricing();
  const { t } = useI18n();

  const plan = (months ? planByMonths(months) : null) || defaultPlan;

  if (pricingLoading || !plan) {
    return (
      <div
        className="mt-8 rounded-xl border border-[#1B84FF]/30 bg-[#1B84FF]/10 p-4"
        data-testid={`${testId}-skeleton`}
        aria-busy="true"
      >
        <div className="h-3 w-28 animate-pulse rounded bg-slate-200" />
        <div className="mt-3 h-7 w-36 animate-pulse rounded bg-slate-200" />
        <div className="mt-3 h-3 w-48 animate-pulse rounded bg-slate-200" />
      </div>
    );
  }

  const m = Number(plan.duration_months);

  return (
    <div
      className="mt-8 rounded-xl border border-[#1B84FF]/30 bg-gradient-to-r from-[#1B84FF]/20 to-[#1B84FF]/10 p-4"
      data-testid={testId}
      data-plan-version={plan.version}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <p className="text-sm text-slate-500">{t("auth.full_membership")}</p>
          <p className="text-2xl font-bold text-[#0B2545]" data-testid={`${testId}-amount`}>
            {planPriceLabel(m)}
          </p>
          {plan.display_estimate && (
            <p className="mt-1 text-xs text-slate-500" data-testid={`${testId}-charge-note`}>
              {t("pricing.charge_real", { pen: planChargeLabel(m) })}
            </p>
          )}
        </div>
        <div className="shrink-0 text-right">
          <p className="font-semibold text-[#1B84FF]" data-testid={`${testId}-name`}>{plan.name}</p>
          <p className="text-sm text-slate-500">{t("auth.of_protection")}</p>
        </div>
      </div>
      {plan.display_estimate && (
        <p className="mt-2 text-[11px] leading-relaxed text-slate-500" data-testid={`${testId}-approx-hint`}>
          {approxHint()}
        </p>
      )}
      {!plan.display_estimate && noEstimateNote() && (
        <p className="mt-2 text-[11px] leading-relaxed text-slate-500" data-testid={`${testId}-no-estimate`}>
          {noEstimateNote()}
        </p>
      )}
    </div>
  );
};

export default AuthPlanCard;
